/**
 * Mobile debugging utilities for troubleshooting mobile-specific issues
 */

export const isMobileDevice = (): boolean => {
  if (typeof window === "undefined") return false;

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const getMobileInfo = () => {
  if (typeof window === "undefined") return null;

  return {
    userAgent: navigator.userAgent,
    isMobile: isMobileDevice(),
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    devicePixelRatio: window.devicePixelRatio,
    connectionType: (navigator as any).connection?.effectiveType || "unknown",
    cookiesEnabled: navigator.cookieEnabled,
    language: navigator.language,
    onLine: navigator.onLine,
  };
};

export const logMobileError = (error: Error | string, context?: string) => {
  if (!isMobileDevice()) return;

  const mobileInfo = getMobileInfo();
  const errorDetails = {
    error: typeof error === "string" ? error : error.message,
    stack: typeof error === "object" ? error.stack : undefined,
    context,
    mobileInfo,
    timestamp: new Date().toISOString(),
  };

  console.error("🔍 Mobile Error:", errorDetails);

  // You could also send this to a logging service
  // logToService(errorDetails);
};

export const logMobileNetworkError = (networkError: any, context: string) => {
  if (!isMobileDevice()) return;

  logMobileError(
    `Network Error: ${networkError.message || "Unknown network error"}`,
    context
  );
};
